import { render } from "./KelolaView.vue?vue&type=template&id=a8028570"
import script from "./KelolaView.vue?vue&type=script&lang=js"
export * from "./KelolaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b5029c4e2822f65c6b0ae42e2fbfada5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__